module.exports = __webpack_public_path__ + "static/img/4-06.76eb7dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/4-06.png
// module id = 29
// module chunks = 0